import { ReactNode, useMemo } from 'react'
import { SdirFooter, SdirHeader, SkipLink } from '@sdir/sds'
import { useLanguage } from '@i18n'
import './SdirLayout.css'

const maxContentWidth = '1490px'

type SdirLayoutProps = {
  children: ReactNode
}

export const SdirLayout = ({ children }: SdirLayoutProps) => {
  const { language, setLanguage, t } = useLanguage()
  const nextLanguage = language === 'nb' ? 'en' : 'nb'

  const aboutLinks = useMemo(
    () => [
      {
        text: t('footer.privacy'),
        url: 'https://www.sdir.no/om-oss/personvernerklaring/',
      },
      {
        text: t('footer.accessibility'),
        url: 'https://uustatus.no/nb/erklaringer/publisert/78f546ff-ec49-4bd1-a5c6-6d8cd10c4c97',
        type: 'external' as const,
      },
    ],
    [t]
  )

  const socialLinks = useMemo(
    () => [
      {
        text: t('footer.facebook'),
        url: 'https://www.facebook.com/sjofartsdir',
        type: 'facebook' as const,
      },
      {
        text: t('footer.instagram'),
        url: 'https://www.instagram.com/sjofartsdir/',
        type: 'instagram' as const,
      },
      {
        text: t('footer.linkedIn'),
        url: 'https://www.linkedin.com/company/41031/',
        type: 'linkedin' as const,
      },
    ],
    [t]
  )

  return (
    <>
      <SkipLink linkText={t('layout.skipToContent')} mainContentId="app-main" />
      <div className="sdir-layout__sds-scale sdir-layout__sds-header">
        <SdirHeader
          appName={t('app.title')}
          backLink={{
            url: 'https://sdir.no',
            text: t('layout.sdirLink'),
          }}
          maxContentWidth={maxContentWidth}
        />
        <button
          type="button"
          className="sdir-layout__language-toggle"
          aria-label={language === 'nb' ? t('language.switchToEnglish') : t('language.switchToNorwegian')}
          onClick={() => setLanguage(nextLanguage)}
        >
          <span className="sdir-layout__language-icon" aria-hidden="true" />
          <span>{t('language.toggleLabel')}</span>
        </button>
      </div>
      {children}
      <div className="sdir-layout__sds-scale sdir-layout__sds-footer">
        <SdirFooter
          tagline={t('footer.tagline')}
          maxContentWidth={maxContentWidth}
          aboutHeader={t('footer.about')}
          aboutLinks={aboutLinks}
          socialHeader={t('footer.followUs')}
          socialLinks={socialLinks}
        />
      </div>
    </>
  )
}

export default SdirLayout
